/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsHash: {
  name: 'hash';
  data: string;
} = {
  name: 'hash',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M14.707 4.707a1 1 0 0 0-1.414-1.414L12 4.586l-1.293-1.293a1 1 0 0 0-1.414 1.414L10.586 6 6 10.586 4.707 9.293a1 1 0 0 0-1.414 1.414L4.586 12l-1.293 1.293a1 1 0 1 0 1.414 1.414L6 13.414 10.586 18l-1.293 1.293a1 1 0 1 0 1.414 1.414L12 19.414l1.293 1.293a1 1 0 0 0 1.414-1.414L13.414 18 18 13.414l1.293 1.293a1 1 0 0 0 1.414-1.414L19.414 12l1.293-1.293a1 1 0 0 0-1.414-1.414L18 10.586 13.414 6l1.293-1.293ZM12 16.586 16.586 12 12 7.414 7.414 12 12 16.586Z" fill="currentColor"/></svg>`,
};
